document.addEventListener('DOMContentLoaded', function () {
  // ===== 全ページ共通の機能 =====
  setupHamburgerMenu();
  setupVideoSource();

  // 現在のパスとホスト名を取得
  const path = window.location.pathname;
  const hostname = window.location.hostname;

  // 仮想ページの判定（本ドメインとサブドメインの両方に対応）
  const isVirtualPage =
    // サブドメイン環境の判定
    hostname.includes('1965diver') ||
    hostname.includes('1968diver') ||
    hostname.includes('speedtimer') ||
    hostname.includes('alpinist') ||
    // 本ドメイン環境の判定
    path.includes('/1965diver') ||
    path.includes('/1968diver') ||
    path.includes('/speedtimer') ||
    path.includes('/alpinist');

  // ===== トップページ専用の機能 =====
  if (!isVirtualPage) {
    setupScrollFadeIn(); // スクロールフェードイン機能を実行
  }
  // ===== 下層ページ共通の機能 =====
  else {
    setupSubSlide(); // 下層ページ共通のスライド機能を実行

    // ===== 各仮想ページ専用の機能 =====
    // 1965diverページ専用の機能
    if (hostname.includes('1965diver') || path.includes('/1965diver')) {
      // ここに1965diver固有の機能を追加
    }
    // 1968diver Scubaページ専用の機能
    else if (hostname.includes('1968diver') || path.includes('/1968diver')) {
      // ここに1968diver固有の機能を追加
    }
    // SPEEDTIMERページ専用の機能
    else if (hostname.includes('speedtimer') || path.includes('/speedtimer')) {
      // ここにSPEEDTIMER固有の機能を追加
    }
    // Alpinistページ専用の機能
    else if (hostname.includes('alpinist') || path.includes('/alpinist')) {
      // ここにAlpinist固有の機能を追加
    }
  }
});

// ハンバーガーボタン・ドロワーメニュー開閉制御
function setupHamburgerMenu() {
  // ハンバーガーボタンとドロワーナビゲーションの選択
  var hamburgers = document.querySelectorAll('.js-hamburger');
  var drawers = document.querySelectorAll('.js-drawer');

  // ドロワーメニューを閉じる共通関数
  function closeDrawer(drawer, hamburger) {
    if (drawer && drawer.classList.contains('active')) {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');

      if (hamburger) {
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    }
  }

  // 各ハンバーガーボタンにイベントリスナーを追加
  hamburgers.forEach(function (hamburger, index) {
    hamburger.addEventListener('click', function (e) {
      e.stopPropagation(); // ボタンクリック時はdocumentのクリックイベントを発火させない

      var expanded = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.classList.toggle('active');
      hamburger.setAttribute('aria-expanded', !expanded);

      // 対応するドロワーを取得して制御
      var drawer = drawers[index];
      if (drawer) {
        drawer.classList.toggle('active');
        drawer.setAttribute('aria-hidden', expanded);
      }
    });
  });

  // ドロワー内のクリックイベントの伝播を停止（ドロワー内クリックでメニューが閉じないようにする）
  drawers.forEach(function (drawer) {
    drawer.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  // ドキュメント全体のクリックでドロワーを閉じる
  document.addEventListener('click', function () {
    drawers.forEach(function (drawer, index) {
      closeDrawer(drawer, hamburgers[index]);
    });
  });

  // ESCキーでドロワーを閉じる機能追加
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      drawers.forEach(function (drawer, index) {
        closeDrawer(drawer, hamburgers[index]);
      });
    }
  });
}

// 共通コンポーネントのスクロールフェードイン実装
function setupScrollFadeIn() {
  // フェードインクラス定義
  const fadeClasses = ['.c-scroll-fadein', '.c-scroll-fadein--left', '.c-scroll-fadein--right', '.c-scroll-fadein--bottom'];

  // 各クラスに対してScrollTriggerを設定
  fadeClasses.forEach(className => {
    const elements = document.querySelectorAll(className);

    // 要素が存在する場合のみ処理を実行
    if (elements.length > 0) {
      elements.forEach(element => {
        ScrollTrigger.create({
          trigger: element,
          start: 'top 75%', // 画面の下から75%の位置でトリガー
          once: true, // 1回だけ実行
          onEnter: () => {
            element.classList.add('is-active');
          }
        });
      });
    }
  });
}

// PC/SPそれぞれで動画の出力分けをする機能
function setupVideoSource() {
  const videos = document.querySelectorAll('.js-video');
  const isSP = window.matchMedia('(max-width: 767px)').matches;

  videos.forEach(video => {
    const src = isSP ? video.dataset.srcSp : video.dataset.srcPc;
    const source = document.createElement('source');
    source.setAttribute('src', src);
    source.setAttribute('type', 'video/mp4');
    video.appendChild(source);
    video.load();
  });
}

//下層ページ共通のスライド機能
function setupSubSlide() {
  // 動画の表示回数を管理する変数
  let videoShownCount = 0;

  // ファーストビュー動画（1枚目の縦スライド）
  const mvVideo = document.querySelector('#vertical-slide .js-p-sub-slide__mv-movie');

  function resetMvVideo() {
    if (!mvVideo) return;
    mvVideo.pause();
    mvVideo.currentTime = 0;
  }

  function playMvVideoFromStart() {
    if (!mvVideo) return;
    mvVideo.currentTime = 0;
    mvVideo.play().catch(function () {});
  }

  /**
   * 横スライド内の動画をループ再生で再開する
   * @param {HTMLVideoElement|null} video - 対象の動画要素
   */
  function resumeHorizontalVideo(video) {
    if (!video) return;
    video.loop = true;
    video.play().catch(function () {});
  }

  if (mvVideo) {
    mvVideo.autoplay = false;
    mvVideo.pause();
    mvVideo.currentTime = 0;
  }

  // 縦スライドの初期化
  const verticalSlider = new Splide('#vertical-slide', {
    direction: 'ttb', // 縦方向へのスライド
    height: '100svh', // ビューポートの高さいっぱいに表示
    heightRatio: 1, // アスペクト比を1:1に設定
    perPage: 1, // 1ページあたりのスライド数
    perMove: 1, // 1回の移動で動かすスライド数
    gap: 0, // スライド間の間隔
    arrows: false, // 矢印ナビゲーションを非表示
    pagination: true, // ページネーションを表示
    speed: 1000, // トランジションの速度（ミリ秒）
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', // イージング（アニメーションの緩急）
    waitForTransition: true, // トランジション完了を待ってから次の操作を受け付ける
    autoplay: false, // 自動再生を無効化
    loop: false, // ループを無効化
    pauseOnHover: false, // ホバー時の一時停止を無効化
    pauseOnFocus: false, // フォーカス時の一時停止を無効化
    trimSpace: false, // 余分なスペースの削除を無効化
    focus: 'center', // フォーカス位置を中央に設定
    isNavigation: false, // ナビゲーションとしての機能を無効化
    updateOnMove: true, // 移動時に状態を更新
    throttle: 300, // イベントの間引き時間（ミリ秒）
    wheel: true, // マウスホイールでの操作を有効化
    releaseWheel: true, // ホイールの解放を有効化
    classes: {
      pagination: 'splide__pagination p-sub-slide__pagination', // ページネーションのクラス名
      page: 'splide__pagination__page p-sub-slide__pagination-page' // ページネーションドットのクラス名
    }
  });

  // 縦スライドの移動時にvideoShownCountをリセット
  verticalSlider.on('move', () => {
    videoShownCount = 0;
  });

  // 横スライドの初期化関数
  const initHorizontalSlider = element => {
    const slider = new Splide(element, {
      type: 'slide',
      direction: 'ltr',
      height: '100svh',
      heightRatio: 1,
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: true, // 矢印ナビゲーションを表示
      pagination: false,
      speed: 1000,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      waitForTransition: true,
      autoplay: false,
      loop: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      trimSpace: false,
      focus: 'center',
      isNavigation: false,
      updateOnMove: true,
      throttle: 300,
      drag: true,
      snap: true,
      classes: {
        arrows: 'splide__arrows p-sub-slide__arrows', // 矢印ナビゲーションのクラス名（仮）
        arrow: 'splide__arrow p-sub-slide__arrow', // 矢印のクラス名（仮）
        prev: 'splide__arrow--prev p-sub-slide__arrow--prev' // 前へ矢印のクラス名（仮）
      },
      onMoved: (splide, newIndex) => {
        if (newIndex === splide.length - 1) {
          setTimeout(() => {
            splide.go(0, true);
            const firstSlide = splide.Components.Elements.slides[0];
            const video = firstSlide ? firstSlide.querySelector('.p-sub-slide__movie') : null;
            resumeHorizontalVideo(video);
          }, splide.options.speed);
        }
      }
    });

    // 横スライドの動画スライドへ戻った際に再生を再開
    slider.on('moved', newIndex => {
      if (newIndex !== 0) return;
      const currentSlide = slider.Components.Elements.slides[0];
      const video = currentSlide ? currentSlide.querySelector('.p-sub-slide__movie') : null;
      if (video && (video.paused || video.ended)) {
        resumeHorizontalVideo(video);
      }
    });

    // スライダーの初期化後にナビゲーションのイベントリスナーを設定
    slider.on('mounted', () => {
      const prevArrow = element.querySelector('.splide__arrow--prev');
      const nextArrow = element.querySelector('.splide__arrow--next');

      if (prevArrow) {
        prevArrow.addEventListener('click', () => {
          const currentSlide = slider.Components.Elements.slides[slider.index];
          const video = currentSlide.querySelector('video');
          if (video) {
            if (slider.index === 0) {
              video.currentTime = 0;
              video.loop = true;
              video.play();
            }
          }
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', () => {});
      }
    });

    return slider;
  };

  // 横スライドのインスタンスを保持するオブジェクト
  const horizontalSliders = {};

  // 縦スライドの移動時に横スライドを制御
  verticalSlider.on('move', (newIndex, prevIndex) => {
    // ファーストビュー動画の再生（下層ムービーと同様、移動開始時に開始。停止は hidden で行う）
    if (mvVideo && newIndex === 0) {
      playMvVideoFromStart();
    }

    // 実際に縦スライドが切り替わった場合のみ横スライドを制御
    if (newIndex === prevIndex) return;

    const currentSlide = verticalSlider.Components.Elements.slides[newIndex];
    const horizontalSliderElement = currentSlide.querySelector('.splide');

    if (horizontalSliderElement) {
      const sliderId = horizontalSliderElement.id;

      if (!horizontalSliders[sliderId]) {
        horizontalSliders[sliderId] = initHorizontalSlider(horizontalSliderElement);
        horizontalSliders[sliderId].mount();
      }

      const horizontalSlider = horizontalSliders[sliderId];

      // 横スライドの最初のスライドに移動（トランジションなし）
      if (horizontalSlider.Components.Controller.isBusy()) {
        horizontalSlider.options.speed = 0;
        horizontalSlider.go(0, true);
        horizontalSlider.options.speed = 1000;
      } else {
        horizontalSlider.go(0, true);
      }

      // タッチイベントの制御を追加
      const track = horizontalSliderElement.querySelector('.splide__track');
      if (track) {
        track.addEventListener(
          'touchstart',
          () => {
            if (horizontalSlider.Components.Controller.isBusy()) {
              horizontalSlider.options.speed = 0;
              horizontalSlider.go(0);
              horizontalSlider.options.speed = 1000;
            }
          },
          { passive: true }
        );
      }

      // 動画の制御
      const video = currentSlide.querySelector('.p-sub-slide__movie');
      if (video) {
        // 現在のスライドインデックスを取得
        const currentIndex = horizontalSlider.index;
        // 1回目の表示時（最初のスライドで、かつ表示回数が0の場合）
        if (currentIndex === 0 && videoShownCount === 0) {
          videoShownCount = 1;
          video.currentTime = 0;
          video.loop = false; // 1回目はループなし
          video.play();

          // 1回目の動画終了時の処理
          video.addEventListener(
            'ended',
            () => {
              if (horizontalSlider.index < horizontalSlider.length - 1) {
                horizontalSlider.go('>');
              }
            },
            { once: true }
          );
        } else if (currentIndex === 0) {
          // 2回目以降の表示時はループ再生
          video.currentTime = 0;
          video.loop = true;
          video.play();
        }
      } else {
        // 画像の場合、3秒後に次のスライドへ完全にスライド
        if (horizontalSlider.index < horizontalSlider.length - 1) {
          setTimeout(() => {
            // 縦スライドが移動中でない場合のみ横スライドを移動
            if (!verticalSlider.Components.Controller.isBusy()) {
              horizontalSlider.go('>');
            }
          }, 3000);
        }
      }
    }
  });

  // スライド非表示時の動画停止とリセット（実際に別スライドへ移動した場合のみ）
  verticalSlider.on('hidden', slide => {
    if (verticalSlider.index === slide.index) return;

    const slideElement = slide.slide;

    // ファーストビュー動画（下層ムービーと同様、スライドが完全に非表示になってから停止・リセット）
    if (mvVideo && slideElement.contains(mvVideo)) {
      resetMvVideo();
    }

    // 横スライド内の動画
    const video = slideElement.querySelector('.p-sub-slide__movie');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    // 横スライドの状態をリセット
    const horizontalSliderElement = slideElement.querySelector('.splide');
    if (horizontalSliderElement) {
      const sliderId = horizontalSliderElement.id;
      if (horizontalSliders[sliderId]) {
        horizontalSliders[sliderId].options.speed = 0;
        horizontalSliders[sliderId].go(0, true);
        horizontalSliders[sliderId].options.speed = 1000;
      }
    }
  });

  // 境界スクロール等で一時的に非表示になったスライドが再表示された際、動画を再開
  verticalSlider.on('visible', slide => {
    if (verticalSlider.index !== slide.index) return;

    const slideElement = slide.slide;
    const video = slideElement.querySelector('.p-sub-slide__movie');
    if (!video) return;

    const horizontalSliderElement = slideElement.querySelector('.splide');
    if (!horizontalSliderElement) return;

    const horizontalSlider = horizontalSliders[horizontalSliderElement.id];
    if (!horizontalSlider || horizontalSlider.index !== 0) return;

    if (video.paused || video.ended) {
      resumeHorizontalVideo(video);
    }
  });

  // 縦スライドのマウント
  verticalSlider.mount();

  // ファーストビューの動画は初回表示時に再生
  if (mvVideo) {
    playMvVideoFromStart();
  }

  // マウント完了後にページネーション制御を実行
  setTimeout(() => {
    const pagination = document.querySelector('.p-sub-slide__pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }
  }, 0);

  // ページネーションの表示制御
  verticalSlider.on('move', newIndex => {
    const pagination = document.querySelector('.p-sub-slide__pagination');
    if (pagination) {
      if (newIndex === 0) {
        pagination.style.display = 'none';
      } else {
        pagination.style.display = 'flex';
      }
    }
  });
}
